module.exports = __webpack_public_path__ + "static/img/captureSymbol.2419328b.png";